import _ from 'lodash'

/**
 * Returns the tree IDs mentioned in the given filters
 */
function treeIdsInFilters(filters) {
	return _(filters)
		.map('trees')
		.map(trees => _.keys(trees))
		.flatten()
		.compact()
		.value()
}

export default treeIdsInFilters

treeIdsInFilters.__filename__ = 'datasets/tree-ids-in-filters.js'
